export const isRoutePass = route => {
  let routePass = false

  if (typeof route === 'string') {
    routePass = window.location.pathname
      .toLowerCase()
      .includes(route.toLowerCase())
  } else if (route instanceof RegExp) {
    routePass = new RegExp(route.source, 'i').test(window.location.pathname)
  }

  return routePass
}
